export const webposEn = {
  // General
  'webpos.title': 'Web POS',
  'webpos.loading': 'Loading Web POS...',
  'webpos.noConnection': 'No server connection — sales not possible. Reconnecting...',
  'webpos.poweredBy': 'Powered by BISpicy POS',

  // Setup
  'webpos.setup.title': 'BISpicy Web POS',
  'webpos.setup.subtitle': 'Set up this register to start selling.',
  'webpos.setup.deviceName': 'Register Name',
  'webpos.setup.deviceNamePlaceholder': 'e.g. Office PC, Counter iPad',
  'webpos.setup.register': 'Register Device',
  'webpos.setup.registering': 'Registering...',
  'webpos.setup.alreadyRegistered': 'This device is already registered.',
  'webpos.setup.registerNotAllowed': 'A new device can only be set up by an administrator or manager (device management permission). Please sign in to BIS ERP on this device with such an account.',

  // License
  'webpos.license.required': 'License Required',
  'webpos.license.instructions': 'Please assign a license to this Web POS in the customer portal.',
  'webpos.license.howTo': 'How to:',
  'webpos.license.step1': '1. Open customer portal',
  'webpos.license.step2': '2. Go to "My Devices"',
  'webpos.license.step3': '3. Find this Web POS',
  'webpos.license.step4': '4. Click "Assign License"',
  'webpos.license.goToPortal': 'Go to Customer Portal',
  'webpos.license.reload': 'Reload page (after license assignment)',

  // Login
  'webpos.login.title': 'Enter Employee PIN',
  'webpos.login.pinTooShort': 'PIN must be at least 4 digits',
  'webpos.login.invalidPin': 'Invalid PIN',
  'webpos.login.withoutPin': 'Continue without PIN',

  // Sales
  'webpos.sales.search': 'Search / Scan barcode...',
  'webpos.sales.allCategories': 'All',
  'webpos.sales.favorites': 'Favorites only',
  'webpos.sales.parkSale': 'Park sale',
  'webpos.sales.noProducts': 'No products available',
  'webpos.sales.noResults': 'No products found',

  // Cart
  'webpos.cart.title': 'Cart',
  'webpos.cart.empty': 'Cart is empty',
  'webpos.cart.clear': 'Clear',
  'webpos.cart.subtotal': 'Subtotal',
  'webpos.cart.discount': 'Discount',
  'webpos.cart.total': 'Total',
  'webpos.cart.vat': 'VAT',
  'webpos.cart.pay': 'Pay',
  'webpos.cart.items': 'items',

  // Payment
  'webpos.payment.title': 'Payment',
  'webpos.payment.toPay': 'Amount due',
  'webpos.payment.cash': 'Cash',
  'webpos.payment.card': 'Card',
  'webpos.payment.split': 'Split Payment (Cash + Card)',
  'webpos.payment.promptpay': 'PromptPay QR',
  'webpos.payment.given': 'Tendered',
  'webpos.payment.change': 'Change',
  'webpos.payment.exact': 'Exact',
  'webpos.payment.process': 'Process Payment',
  'webpos.payment.processing': 'Processing sale...',
  'webpos.payment.success': 'Sale Completed',
  'webpos.payment.nextCustomer': 'Next Customer',
  'webpos.payment.back': 'Back',

  // Cash Session
  'webpos.cashSession.open': 'Open Register',
  'webpos.cashSession.close': 'Close Register (Z-Report)',
  'webpos.cashSession.cashier': 'Cashier',
  'webpos.cashSession.denomination': 'Denomination (Opening Balance)',
  'webpos.cashSession.initialAmount': 'Opening Balance',
  'webpos.cashSession.openCash': 'Open Register',
  'webpos.cashSession.opening': 'Opening...',
  'webpos.cashSession.countedAmount': 'Counted Cash',
  'webpos.cashSession.closeCash': 'Close Register',
  'webpos.cashSession.closing': 'Closing...',
  'webpos.cashSession.expected': 'EXPECTED',
  'webpos.cashSession.actual': 'ACTUAL (counted)',
  'webpos.cashSession.difference': 'Difference',
  'webpos.cashSession.cashSales': 'Cash Sales',
  'webpos.cashSession.deposits': 'Deposits',
  'webpos.cashSession.withdrawals': 'Withdrawals',

  // Cash Movement
  'webpos.cashMovement.title': 'Cash Movement',
  'webpos.cashMovement.deposit': 'Deposit',
  'webpos.cashMovement.withdrawal': 'Withdrawal',
  'webpos.cashMovement.amount': 'Amount',
  'webpos.cashMovement.category': 'Category',
  'webpos.cashMovement.reason': 'Reason (optional)',
  'webpos.cashMovement.bookDeposit': 'Book Deposit',
  'webpos.cashMovement.bookWithdrawal': 'Book Withdrawal',

  // Discounts
  'webpos.discount.title': 'Discount',
  'webpos.discount.presets': 'Presets',
  'webpos.discount.custom': 'Custom',
  'webpos.discount.percent': 'Percentage Discount',
  'webpos.discount.fixed': 'Fixed Amount',
  'webpos.discount.apply': 'Apply Discount',

  // Vouchers
  'webpos.voucher.title': 'Redeem Voucher',
  'webpos.voucher.enterCode': 'Enter voucher code...',
  'webpos.voucher.remaining': 'Remaining Value',
  'webpos.voucher.redeemAmount': 'Amount to Redeem',
  'webpos.voucher.redeem': 'Redeem Voucher',
  'webpos.voucher.redeemed': 'Voucher Redeemed!',
  'webpos.voucher.notFound': 'Voucher not found',
  'webpos.voucher.expired': 'Voucher has expired',

  // Customer
  'webpos.customer.title': 'Assign Customer',
  'webpos.customer.search': 'Name, email, phone or customer number...',
  'webpos.customer.none': 'No customers found',
  'webpos.customer.remove': 'Remove',

  // Deposit Return
  'webpos.deposit.title': 'Deposit Return',
  'webpos.deposit.payout': 'Payout',
  'webpos.deposit.confirm': 'Pay out deposit',

  // History
  'webpos.history.title': 'Sales History',
  'webpos.history.receipts': 'receipts',
  'webpos.history.searchReceipt': 'Search receipt number...',
  'webpos.history.noSales': 'No sales found',
  'webpos.history.cancelled': 'Cancelled',
  'webpos.history.printReceipt': 'Print Receipt',
  'webpos.history.cancel': 'Void',
  'webpos.history.cancelTitle': 'Void Sale',
  'webpos.history.cancelReason': 'Please provide a reason for voiding.',
  'webpos.history.cancelReasons.customerRequest': 'Customer request',
  'webpos.history.cancelReasons.wrongItem': 'Wrong item',
  'webpos.history.cancelReasons.wrongPrice': 'Wrong price',
  'webpos.history.cancelReasons.wrongQuantity': 'Wrong quantity',
  'webpos.history.cancelReasons.duplicate': 'Duplicate',
  'webpos.history.cancelReasons.other': 'Other',

  // Gastro / Tables
  'webpos.gastro.free': 'free',
  'webpos.gastro.occupied': 'occupied',
  'webpos.gastro.noTables': 'No tables configured',
  'webpos.gastro.addTable': 'Add Table',
  'webpos.gastro.tableNumber': 'Table Number',
  'webpos.gastro.capacity': 'Capacity',
  'webpos.gastro.createTable': 'Create Table',
  'webpos.gastro.order': 'Order',
  'webpos.gastro.products': 'Products',
  'webpos.gastro.settle': 'Settle',
  'webpos.gastro.sendToKitchen': 'Send to Kitchen',
  'webpos.gastro.sending': 'Sending...',
  'webpos.gastro.noItems': 'No items ordered yet',
  'webpos.gastro.statusNew': 'New',
  'webpos.gastro.statusSent': 'Kitchen',

  // Settings
  'webpos.settings.title': 'Settings',
  'webpos.settings.deviceInfo': 'Device Info',
  'webpos.settings.printer': 'Printer',
  'webpos.settings.printMode': 'Print Mode',
  'webpos.settings.printModeBisprint': 'BISPrint',
  'webpos.settings.printModeBisprintDesc': 'Cloud printing via BISPrint client',
  'webpos.settings.printModeBrowser': 'Browser Print',
  'webpos.settings.printModeBrowserDesc': 'HTML receipt via window.print()',
  'webpos.settings.defaultPrinter': 'Default Printer',
  'webpos.settings.savePrintSettings': 'Save Print Settings',
  'webpos.settings.saved': 'Saved',
  'webpos.settings.customerDisplay': 'Customer Display',
  'webpos.settings.customerDisplayDesc': 'Open this URL on a second screen or tablet to show the cart live to customers.',
  'webpos.settings.shortcuts': 'Keyboard Shortcuts',

  // Menu
  'webpos.menu.openCash': 'Open Register (F8)',
  'webpos.menu.closeCash': 'Close Register (F8)',
  'webpos.menu.cashMovement': 'Cash Movement',
  'webpos.menu.depositReturn': 'Deposit Return',
  'webpos.menu.history': 'Sales History',
  'webpos.menu.settings': 'Settings',
  'webpos.menu.shortcuts': 'Shortcuts:',

  // Customer Display
  'webpos.display.welcome': 'Welcome!',
  'webpos.display.thankYou': 'Thank you for your purchase!',
  'webpos.display.pleasePayTitle': 'Please pay',
  'webpos.display.total': 'Total',

  // Common
  'webpos.common.cancel': 'Cancel',
  'webpos.common.close': 'Close',
  'webpos.common.save': 'Save',
  'webpos.common.delete': 'Delete',
  'webpos.common.or': 'or',
  'webpos.common.previous': 'Previous',
  'webpos.common.next': 'Next',
  'webpos.common.saving': 'Saving...',
  'webpos.common.loading': 'Loading customers...',
  'webpos.common.reload': 'Reload',
  'webpos.common.edit': 'Edit',

  // Customers (WebPOS Customer CRUD)
  'webpos.customers.title': 'Customers',
  'webpos.customers.subtitle': 'Manage customer master data — in sync with POS app & customer center',
  'webpos.customers.add': 'Add customer',
  'webpos.customers.searchPlaceholder': 'Search by name, company, number, email or phone',
  'webpos.customers.statTotal': 'Total',
  'webpos.customers.statActive': 'Active',
  'webpos.customers.statInactive': 'Inactive',
  'webpos.customers.colNumber': 'No.',
  'webpos.customers.colName': 'Name',
  'webpos.customers.colContact': 'Contact',
  'webpos.customers.colAddress': 'Address',
  'webpos.customers.colDiscount': 'Discount',
  'webpos.customers.colStatus': 'Status',
  'webpos.customers.active': 'Active',
  'webpos.customers.inactive': 'Inactive',
  'webpos.customers.unnamed': '(Unnamed)',
  'webpos.customers.pageInfo': 'Page {{page}} of {{pages}} · {{total}} customers',
  'webpos.customers.emptyState': 'No customers yet.',
  'webpos.customers.noResultsSearch': 'No customers match your search.',
  'webpos.customers.loadFailed': 'Loading failed',
  'webpos.customers.saveFailed': 'Save failed',
  'webpos.customers.deleteFailed': 'Delete failed',
  'webpos.customers.created': 'Customer created',
  'webpos.customers.updated': 'Customer saved',
  'webpos.customers.deleted': 'Customer deactivated',
  'webpos.customers.createTitle': 'New customer',
  'webpos.customers.editTitle': 'Edit customer',
  'webpos.customers.createBtn': 'Create',
  'webpos.customers.deleteConfirmTitle': 'Deactivate customer?',
  'webpos.customers.deleteConfirmMessage': 'The customer will be set to "inactive". Existing invoices and receipts remain untouched.',
  'webpos.customers.secBasics': 'Master data',
  'webpos.customers.secContact': 'Contact',
  'webpos.customers.secAddress': 'Billing address',
  'webpos.customers.secConditions': 'Terms',
  'webpos.customers.secNotes': 'Notes & status',
  'webpos.customers.fCustomerNumber': 'Customer number',
  'webpos.customers.fCustomerNumberHint': 'Empty = auto',
  'webpos.customers.fCompanyName': 'Company',
  'webpos.customers.fFirstName': 'First name',
  'webpos.customers.fLastName': 'Last name',
  'webpos.customers.fEmail': 'Email',
  'webpos.customers.fPhone': 'Phone',
  'webpos.customers.fMobile': 'Mobile',
  'webpos.customers.fVatId': 'VAT ID',
  'webpos.customers.fStreet': 'Street',
  'webpos.customers.fHouseNumber': 'No.',
  'webpos.customers.fPostalCode': 'Postal code',
  'webpos.customers.fCity': 'City',
  'webpos.customers.fCountry': 'Country',
  'webpos.customers.fDiscount': 'Discount (%)',
  'webpos.customers.fPaymentTerms': 'Payment terms (days)',
  'webpos.customers.fNotes': 'Internal notes',
  'webpos.customers.fActive': 'Customer is active',

  // Install as app / fullscreen
  'webpos.install.title': 'Open POS in fullscreen',
  'webpos.install.subtitle': 'No browser bar – as an icon on the home screen, like an app.',
  'webpos.install.benefit1': 'Fullscreen without address or menu bar',
  'webpos.install.benefit2': 'Own register icon on the home screen',
  'webpos.install.benefit3': 'Opens straight into fullscreen',
  'webpos.install.button': 'Add to Home Screen',
  'webpos.install.later': 'Later',
  'webpos.install.dontShowAgain': "Don't show again",
  'webpos.install.iosTitle': 'Fullscreen in 2 steps',
  'webpos.install.iosStep1': 'Tap the Share icon below',
  'webpos.install.iosStep2': 'Choose "Add to Home Screen"',
  'webpos.install.iosHint': 'Then open the register via the new icon – it runs fullscreen without a browser bar.',
  'webpos.install.menuLabel': 'Open in fullscreen',
  'webpos.install.iosOtherTitle': 'Use Safari for fullscreen',
  'webpos.install.iosOtherHint': "This browser can't set up fullscreen on iPhone/iPad. Please open pos.bispicy.com in Safari, then choose \"Share → Add to Home Screen\".",
  'webpos.install.androidTitle': 'Fullscreen in 2 steps',
  'webpos.install.androidStep1': 'Open the browser menu (⋮)',
  'webpos.install.androidStep2': 'Choose "Add to Home screen"',
  'webpos.install.androidHint': 'Then open the register via the new icon – fullscreen without a browser bar.',
  'webpos.install.fullscreenNow': 'Open fullscreen now instead',

  // Navigation drawer (☰) — labels 1:1 from the native register app
  'webpos.nav.dashboard': 'Overview',
  'webpos.nav.sales': 'Sales',
  'webpos.nav.repairOrders': 'Repair Orders',
  'webpos.nav.tablePlan': 'Table Plan',
  'webpos.nav.salesHistory': 'Sales History',
  'webpos.nav.products': 'Products',
  'webpos.nav.customers': 'Customers',
  'webpos.nav.appointments': 'Appointments',
  'webpos.nav.reports': 'Reports',
  'webpos.nav.settings': 'Settings',
  'webpos.drawer.logout': 'Log out',
  'webpos.drawer.language': 'Language',
  'webpos.drawer.fullscreen': 'Open in fullscreen',

  // Dashboard / Overview
  'webpos.dashboard.title': 'Overview',
  'webpos.dashboard.todayRevenue': 'Revenue today',
  'webpos.dashboard.todaySales': 'Receipts today',
  'webpos.dashboard.products': 'Products',
  'webpos.dashboard.customers': 'Customers',
  'webpos.dashboard.lowStock': 'Out of stock',

  // V-0642: Cash register notification (§ 146a para. 4 AO) on the TSE page — the business reports it itself.
  'webpos.tse.kassenmeldung_titel': 'Register notification',
  'webpos.tse.kassenmeldung_text': 'You submit the notification under § 146a para. 4 AO (German Fiscal Code) yourself, via Mein ELSTER or through your tax advisor. The details you need (e.g. the serial number of the TSE, model and short code of the register) can be found in the customer centre under “Procedure documentation”. If you have questions, support will help you.',

  // V-0607: empties return / deposit refund
  'webpos.pfand.title': 'Empties return',
  'webpos.pfand.payout': 'Payout',
  'webpos.pfand.pieces': '{{count}} items',
  'webpos.pfand.confirm': 'Pay out empties',
  'webpos.pfand.empty': 'No deposit types are set up for this business.',
  'webpos.pfand.addFailed': 'The deposit return could not be added.',
  'webpos.pfand.toPay': 'To pay out',
  'webpos.pfand.payoutCash': 'Pay out deposit in cash',
  'webpos.pfand.payoutHint': 'The receipt is negative: the money is paid out in cash from the register.',
  'webpos.pfand.payoutFailed': 'The payout failed.',

  // V-0582: receipt printing via BISPrint
  'webpos.print.noReceiptPrinter': 'No receipt printer available — the receipt was not printed.',
  'webpos.print.noKitchenPrinter': 'The assigned kitchen printer is not reachable — the kitchen ticket was not printed. The items have been sent to the kitchen.',
  'webpos.print.receiptFailed': 'The receipt could not be sent to the printer.',
  'webpos.print.kitchenFailed': 'The kitchen ticket could not be sent to the printer. The items have been sent to the kitchen.',
  'webpos.print.sent': 'Receipt sent to the printer.',
  'webpos.print.settings.saveFailed': 'The print setting could not be saved.',
  'webpos.print.settings.receiptPrinterHint': 'Without a selection the receipt prints on the receipt printer assigned in BIS ERP, otherwise on the default printer of the BISPrint workstation.',
  'webpos.print.settings.autoPrint': 'Print the receipt automatically after each sale',
  'webpos.print.settings.autoPrintHint': 'The receipt is printed via BISPrint after every sale. Printing from the sales history works independently of this.',
  'webpos.print.settings.autoPrintOff': 'Automatic receipt printing has so far been off for this register. Switch it on and save if every sale should be printed automatically.',
  'webpos.print.settings.kitchenPrinter': 'Kitchen printer',
  'webpos.print.settings.autoPrintNeedsBisprint': 'Only effective in the print mode “BISPrint Cloud”. With browser printing (also if never chosen) no receipt is printed automatically.',
  'webpos.print.settings.kitchenPrinterHint': 'The kitchen ticket is only printed on “Send to kitchen” if a printer is assigned here or in BIS ERP (Settings → Printing, document type “Kitchen ticket”).',
  'webpos.print.settings.kitchenPrinterDefault': 'None (unless assigned centrally in BIS ERP)',
  'webpos.print.settings.offline': 'offline',
};

